module.exports = __webpack_public_path__ + "static/3-2113ee10aa9914b0367725ee377bee65.png";